import { useState } from "react";

const FromTo = (props) => {
  const [searchValue, setSearchValue] = useState("Adults");
  const [selectedItem, setSelectedItem] = useState(null);

  const locationSearchContent = [
    {
      id: 1,
      name: "Adults",
      address: "Adults",
    },
    {
      id: 2,
      name: "Children",
      address: "Children",
    },
  ];

  const handleOptionClick = (item) => {
    setSearchValue(item.name);
    setSelectedItem(item);
  };

  return (
    <>
      <div className="searchMenu-loc lg:px-0 js-form-dd js-liverSearch">
        <div
          data-bs-toggle="dropdown"
          data-bs-auto-close="true"
          data-bs-offset="0,22"
        >
          <div className="text-15 text-light-1 ls-2 lh-16">
            <div className="d-flex items-center">
              <h6>{searchValue}</h6>
              <img
                src="/img/filtericons/arrow.svg"
                alt="quote"
                width="20"
                className="mr-10"
              />
            </div>
          </div>
        </div>
        {/* min-width-400 */}
        <div className="shadow-2 dropdown-menu w-100">
          <div className="bg-white px-20 py-20 sm:px-0 sm:py-15 rounded-4">
            <ul className="y-gap-5 js-results">
              {locationSearchContent.map((item) => (
                <li
                  className={`-link d-block col-12 text-left rounded-4 px-20 py-15 js-search-option mb-1 ${
                    selectedItem && selectedItem.id === item.id ? "active" : ""
                  }`}
                  key={item.id}
                  role="button"
                  onClick={() => handleOptionClick(item)}
                >
                  <div className="d-flex">
                    {/* <div className="icon-location-2 text-light-1 text-20 pt-4" /> */}
                    <div className="ml-10">
                      <div className="text-15 lh-12 fw-500 js-search-option-target">
                        {item.name}
                      </div>
                      {/* <div className="text-14 lh-12 text-light-1 mt-5">
                        {item.address}
                      </div> */}
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default FromTo;
